import { array, number, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import {
    getFieldsToRender,
    getMinMaxFrontBaseHeight,
    getMinMaxOuterRailLength,
    getMinMaxRailSpacing,
} from 'common/utils/helpers/systemsValues';

export default (values) => {
    const {
        NUMBER_TYPE_TEXT,
        REQUIRED_TEXT,
        getMinValueText,
        getMaxValueText,
    } = getValidationTexts();

    const { system_uniqueid } = values;

    const extraFieldsToValidate = getFieldsToRender(system_uniqueid);

    const extraFields = {};

    if (extraFieldsToValidate.includes('rail_spacing')) {
        const { strategy } = values.rail_spacing;
        if (strategy === 'manual') {
            extraFields.rail_spacing = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: array()
                    .of(string())
                    .min(1, 'Selecciona al menos 1 opción')
                    .required(REQUIRED_TEXT),
            });
        } else if (strategy === 'custom') {
            const [minValue, maxValue] = getMinMaxRailSpacing();
            extraFields.rail_spacing = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                custom_value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        } else
            extraFields.rail_spacing = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('rail_support_length')) {
        const { strategy } = values.rail_support_length;
        if (strategy === 'manual') {
            extraFields.rail_support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: string().required(REQUIRED_TEXT),
            });
        } else
            extraFields.rail_support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('plate_support_length')) {
        const { strategy } = values.plate_support_length;
        if (strategy === 'manual') {
            extraFields.plate_support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: string().required(REQUIRED_TEXT),
            });
        } else
            extraFields.plate_support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('beam_spacing')) {
        const { strategy } = values.beam_spacing;
        if (strategy === 'manual') {
            extraFields.beam_spacing = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: string().required(REQUIRED_TEXT),
            });
        } else
            extraFields.beam_spacing = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('support_length')) {
        const { strategy } = values.support_length;
        if (strategy === 'manual') {
            extraFields.support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: string().required(REQUIRED_TEXT),
            });
        } else
            extraFields.support_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('lfoot_supports_width')) {
        const { strategy } = values.lfoot_supports_width;
        if (strategy === 'manual') {
            extraFields.lfoot_supports_width = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: string().required(REQUIRED_TEXT),
            });
        } else
            extraFields.lfoot_supports_width = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('outer_rail_length')) {
        const { strategy } = values.outer_rail_length;
        if (strategy === 'manual') {
            const [minValue, maxValue] = getMinMaxOuterRailLength();
            extraFields.outer_rail_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        } else
            extraFields.outer_rail_length = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    if (extraFieldsToValidate.includes('front_base_height')) {
        const { strategy } = values.front_base_height;
        if (strategy === 'manual') {
            const [minValue, maxValue] = getMinMaxFrontBaseHeight();
            extraFields.front_base_height = object().shape({
                strategy: string().required(REQUIRED_TEXT),
                value: number()
                    .typeError(NUMBER_TYPE_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(minValue, getMinValueText(minValue))
                    .max(maxValue, getMaxValueText(maxValue)),
            });
        } else
            extraFields.front_base_height = object().shape({
                strategy: string().required(REQUIRED_TEXT),
            });
    }

    return object().shape({
        system_id: string().required(REQUIRED_TEXT).nullable(),
        ...extraFields,
    });
};
